import {
  blue,
  deepteal,
  magenta,
  UI_THEMES,
  type UITheme,
} from '@kizen/kds/Colors';

const THEME_COLORS: Record<UITheme, string> = {
  [UI_THEMES.LIGHT]: blue['blue-500'],
  [UI_THEMES.HIGH_CONTRAST]: blue['blue-600'],
  [UI_THEMES.QA]: magenta['magenta-400'],
  [UI_THEMES.BRAND]: deepteal['deepteal-750'],
};

export const applyTheme = (theme?: UITheme | null) => {
  if (theme) {
    document.documentElement.setAttribute(
      'data-kds-theme',
      THEME_COLORS[theme] ? theme : UI_THEMES.LIGHT
    );
    document.head
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute(
        'content',
        THEME_COLORS[theme] ?? THEME_COLORS[UI_THEMES.LIGHT]
      );
  }
};
